// extracted by mini-css-extract-plugin
export var label = "_i1-2";
export var slideContainer = "_i1-0";
export var slider = "_i1-1";